var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{attrs:{"src":require("static/general/we-are-here-to-help.svg"),"alt":_vm.$i18n('general.help-you-out')}})]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":"https://assets.parkos.com/assets/img/static-pages/parkos-team.png","width":"268px","height":"143px","alt":_vm.$i18n('faq.cs-team-picture')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }